import React from 'react';
import { Button as MButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../constants/colors';

const useStyles = makeStyles((theme) => ({
  button: (props) => ({
    margin: theme.spacing(0.75),
    backgroundColor: colors.orange,
    color: colors.white,
    minWidth: props.minWidth ?? 110,
    textTransform:'capitalize',
    fontSize: '12px',

    '&:hover': {
      backgroundColor: colors.orange,
      opacity: 0.8,

    },
    /* xs */
    [theme.breakpoints.down('xs')]: {
      minWidth: 80,
      fontSize: '11px',
      padding: '4px 10px',
    },

    /* sm */
    [theme.breakpoints.only('sm')]: {
      minWidth: 100,
      fontSize: '12px',
      padding: '5px 12px',
    },

    /* md and up */
    [theme.breakpoints.up('md')]: {
      minWidth: props.minWidth ?? 110,
      fontSize: '12px',
    },
  }),
  outlineButton: {
    border: '1px solid' + colors.orange,
    color: colors.orange,
    '&:hover': {
      backgroundColor: colors.orange,
      opacity: 0.8,
      color: colors.white,
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 80,
      fontSize: '11px',
      padding: '4px 10px',
    },

    [theme.breakpoints.only('sm')]: {
      minWidth: 100,
      fontSize: '12px',
      padding: '5px 12px',
    },
  },
}));

export default function Button(props) {
  const classes = useStyles({ ...props });
  const { label, variant, tooltip } = props;

  const buttonElement = (
    <MButton
      variant={variant ? variant : "contained"}
      color="primary"
      className={`${variant ? classes.outlineButton : classes.button} ccl-btn`}
      {...props}
    >
      {label}
    </MButton>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip}
        placement="top"
        arrow 
      >
        {/* span wrapper is needed because tooltips don't trigger on disabled elements */}
        <span>{buttonElement}</span>
      </Tooltip>
    );
  }

  return buttonElement;
}